import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../../lib/api";
import { usePageMeta } from "../../lib/usePageMeta";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  usePageMeta({ title: "Verifica email | Wattline", noindex: true });
  const [params] = useSearchParams();
  const [state, setState] = useState("verifying");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/public/verify-email", { token })
      .then(() => setState("success"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-4" data-testid="verify-page">
      <div className="w-full max-w-md bg-surface border border-border rounded-2xl p-8 text-center">
        {state === "verifying" && (
          <>
            <Loader2 size={36} className="mx-auto animate-spin text-accent mb-4" />
            <p className="text-sm text-text-secondary">Verifica in corso…</p>
          </>
        )}
        {state === "success" && (
          <div data-testid="verify-success">
            <CheckCircle2 size={40} className="mx-auto text-success-strong mb-4" />
            <h1 className="text-lg font-semibold text-text-primary">Email confermata!</h1>
            <p className="text-sm text-text-secondary mt-2">
              La tua prova gratuita di 7 giorni è iniziata: accedi e inizia a lavorare.
            </p>
            <Link to="/login" className="wl-btn wl-btn--primary mt-6 inline-flex" data-testid="verify-login-link">
              Accedi
            </Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <XCircle size={40} className="mx-auto text-danger mb-4" style={{ color: "var(--wl-danger-text)" }} />
            <h1 className="text-lg font-semibold text-text-primary">Link non valido o già usato</h1>
            <p className="text-sm text-text-secondary mt-2">
              Se hai già confermato la tua email, accedi normalmente. Altrimenti richiedi
              un nuovo link dalla pagina di registrazione.
            </p>
            <div className="flex items-center justify-center gap-3 mt-6">
              <Link to="/signup" className="wl-btn wl-btn--ghost" style={{ border: "1px solid var(--wl-border)" }}>Registrazione</Link>
              <Link to="/login" className="wl-btn wl-btn--primary">Accedi</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
